import VueRouter, { RouteConfig } from 'vue-router'

const RankDetail = () => import('../views/RankDetail.vue')
const RankCategoryList = () => import('../views/RankCategoryList.vue')

export const rankDetailRoute: RouteConfig = {
  path: '/rank-detail',
  name: 'rank-detail',
  component: RankDetail,
}

export const rankCategoryRoute: RouteConfig = {
  path: '/rank-category-list',
  name: 'rank_category_list',
  component: RankCategoryList,
}

export default [rankDetailRoute, rankCategoryRoute]

export function navigateToRankDetail(router: VueRouter, clazzId: number) {
  router.push({ name: rankDetailRoute.name, query: { clazzId: `${clazzId}` } })
}

export function navigateToRankCategory(router: VueRouter, clazzId: number) {
  router.push({ name: rankCategoryRoute.name, query: { clazzId: `${clazzId}` } })
}
